import type { IContext } from '../router/models';

export const findRouterByName = <S>(router: IContext<S>, name: string) => {
    let foundRouter: IContext<S> | undefined = router;
    while (foundRouter && foundRouter.name !== name) foundRouter = foundRouter.parent;

    return foundRouter;
};
